import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
/**
 * One passenger line on a B2B invoice. `amount` is the flight price billed to
 * the B2B client, in cents (the agent enters it manually, euros -> cents).
 */
export const b2bInvoicePassengerSchema = z.object({
    name: z.string().min(1),
    amount: z.number().int().min(0),
});
/**
 * One PNR section on a B2B invoice. `compagnie` / `libelle` are pre-built on the
 * client from the Affidium booking fetched at gather time, so the server stays a
 * pure renderer (no Affidium round-trip at generation). `insurancePrice` (cents)
 * is present only when insurance was toggled on for this PNR.
 */
export const b2bInvoicePnrSectionSchema = z.object({
    compagnie: z.string().default(''),
    insurancePrice: z.number().int().min(0).nullish(),
    libelle: z.string().default(''),
    passengers: z.array(b2bInvoicePassengerSchema).min(1),
    pnr: z.string().min(1),
});
/**
 * Génération d'une facture B2B. La facture est toujours rattachée à un client
 * (`clientId` requis) : le serveur en dérive la raison sociale, le contact et
 * l'adresse pour le rendu PDF (source unique de vérité). La facture est ensuite
 * persistée (upload S3 + ligne en base).
 */
export const generateB2bInvoiceSchema = z.object({
    /** Dossier source, quand la facture est déclenchée depuis un booking. Absent
     *  pour les factures manuelles multi-PNR créées via /b2b-invoices/new. */
    bookingId: z.string().min(1).optional(),
    clientId: z.string().min(1, 'Le client est requis.'),
    /** Optional manual override; auto-generated when absent. */
    invoiceNumber: z.string().optional(),
    /** Date limite de paiement (ISO), affichée sur le PDF. */
    paymentDeadline: isoDateString(),
    pnrSections: z.array(b2bInvoicePnrSectionSchema).min(1),
});
